import { InvoiceStateCounterByServiceDelivery } from "../domain/InvoiceStateCounterByServiceDelivery";
import { StateCounterRepository } from "../domain/StateCounterRepository";

export class StateCounterQuery {
  constructor(
    private readonly stateCounterRepository: StateCounterRepository,
  ) {}

  execute(sd_id): Promise<{ [key: string]: InvoiceStateCounterByServiceDelivery[] | string[]; }> {
    return this.stateCounterRepository.get_data(sd_id);
  }
}

